(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@platform/api/index"), require("react-dom"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@platform/api/index", "react-dom", "axios"], factory);
	else if(typeof exports === 'object')
		exports["@platform/base/index"] = factory(require("react"), require("@platform/api/index"), require("react-dom"), require("axios"));
	else
		root["@platform/base/index"] = factory(root["React"], root["@platform/api/index"], root["ReactDOM"], root["axios"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__130__) {
return 